// extracted by mini-css-extract-plugin
export default {"bar":"TabBar_bar__gHn3-","tab":"TabBar_tab__Burxx","active":"TabBar_active__x-0S+"};